<template>
    <div id="loader-website" :class="{ inactive: !$store.state.app.loaderWebsite }" v-if="displayLoader">
        <div>
            <div><img src="@/assets/img/bg_loader.jpg" alt="" /></div>
            <div><img src="@/assets/img/bg_loader.jpg" alt="" /></div>
        </div>

        <div>
            <div>
                <img src="@/assets/img/loader-logo.png" alt="" />
            </div>

            <div class="desc" v-html="$t('message.msg_loader')"></div>

            <div class="loader">
                <IconHaikara color="#FF0000" class="logo-icon" />
                <div class="cm-spinner"></div>
            </div>
        </div>
    </div>
</template>

<script>
import IconHaikara from "./img/IconHaikara.vue";

export default {
    name: "LoaderWebsite",
    data() {
        return {
            displayLoader: true,
        };
    },
    components: {
        IconHaikara,
    },
    watch: {
        "$store.state.app.loaderWebsite": function (display) {
            if (display) document.body.classList.add("hidden");
            else {
                document.body.classList.remove("hidden");
                setTimeout(() => {
                    this.displayLoader = false;
                }, 1500);
            }
        },
    },
    mounted() {
        if (this.$store.state.app.loaderWebsite) document.body.classList.add("hidden");
        else {
            document.body.classList.remove("hidden");
            this.displayLoader = false;
        }

        setTimeout(() => {
            this.$store.dispatch("app/setLoaderWebsite", false);
        }, 3000);
    },
    methods: {},
};
</script>

<style lang="scss">
#loader-website {
    .desc {
        span {
            color: #ff3617;
        }
    }
}
</style>

<style scoped lang="scss">
#loader-website {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 99;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;

    > div {
        &:first-child {
            height: 100%;
            width: 100%;
            position: relative;

            > div {
                position: absolute;
                width: 100%;
                height: 50%;
                transition: all 1s;
                overflow: hidden;

                &:first-child {
                    top: 0;
                    left: 0;
                    right: 0;

                    img {
                        position: absolute;
                        top: 0;
                        left: 0;
                        right: 0;
                        width: 100vw;
                        height: 100vh;
                    }
                }

                &:last-child {
                    bottom: 0;
                    left: 0;
                    right: 0;

                    img {
                        position: absolute;
                        top: -100%;
                        left: 0;
                        right: 0;
                        width: 100vw;
                        height: 100vh;
                    }
                }
            }
        }

        &:last-child {
            text-align: center;
            position: absolute;
        }
    }

    .loader {
        position: relative;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
    }

    .logo-icon {
        width: 80px;
        height: auto;
        position: absolute;
        fill: #fff;
    }

    &.inactive {
        > div {
            &:first-child {
                > div {
                    &:first-child {
                        top: -50%;
                    }

                    &:last-child {
                        bottom: -50%;
                    }
                }
            }

            &:last-child {
                opacity: 0;
            }
        }
    }
}

.desc {
    font-family: Oswald, sans-serif;
    text-align: center;
    font-size: 2rem;
    font-weight: 400;
    max-width: 1400px;
    padding: 4rem 2rem;
    box-sizing: border-box;
    color: #016397;
    text-transform: uppercase;
}

.cm-spinner {
    height: 180px;
    width: 180px;
    border: 8px solid transparent;
    border-radius: 50%;
    border-top: 8px solid #fff;
    border-bottom: 8px solid #fff;
    -webkit-animation: spin 4s linear infinite;
    animation: spin 4s linear infinite;
    position: relative;
}

.cm-spinner::before,
.cm-spinner::after {
    content: "";
    position: absolute;
    top: 6px;
    bottom: 6px;
    left: 6px;
    right: 6px;
    border-radius: 50%;
    border: 8px solid transparent;
}

.cm-spinner::before {
    border-top-color: #fff;
    -webkit-animation: 3s spin linear infinite;
    animation: 3s spin linear infinite;
}

.cm-spinner::after {
    border-top-color: #fff;
    -webkit-animation: spin 1.5s linear infinite;
    animation: spin 1.5s linear infinite;
}

@media (max-width: 1400px) {
}

@media (max-width: 1200px) {
    #loader-website {
        > div {
            &:last-child {
                img {
                    max-width: 90%;
                }
            }
        }

        .logo-icon {
            width: 60px;
        }
    }

    .desc {
        font-size: 1.8rem;
        padding: 4rem 2rem;
    }

    .cm-spinner {
        height: 150px;
        width: 150px;
    }
}

@media (max-width: 992px) {
}

@media (max-width: 768px) {
    #loader-website {
        .logo-icon {
            width: 50px;
        }
    }

    .desc {
        font-size: 1.4rem;
        padding: 4rem 1rem;
    }

    .cm-spinner {
        height: 140px;
        width: 140px;
    }
}

@media (max-width: 576px) {
    #loader-website {
        > div {
            &:last-child {
                img {
                    max-width: 70%;
                }
            }
        }

        .logo-icon {
            width: 40px;
        }
    }

    .desc {
        font-size: 1.2rem;
        padding: 3rem 1rem;
    }

    .cm-spinner {
        height: 120px;
        width: 120px;
    }
}

@-webkit-keyframes spin {
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes spin {
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>
